import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { POP } from '../classes/popModel';
import { CropData } from '../classes/cropdataModel';
import { IndividualHealth } from '../classes/individualHealthModel';
import { CropDataTool } from '../classes/cropdatatoolModel';
import { Product } from '../classes/productModel';
import { TokenStorageService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  gotoMain: EventEmitter<any> = new EventEmitter();
  getProfileData: EventEmitter<any> = new EventEmitter();
  savePopData: EventEmitter<any> = new EventEmitter();
  getPopData: EventEmitter<any> = new EventEmitter();
  totalResidueData: any;
  constructor(public http: HttpClient,private tokenStorageService:TokenStorageService) {
  }
  sendprofileData(profileData) {
    this.getProfileData.emit(profileData);
  }
  async getAllProducts(obj) {
    let body = {
      target: "getProducts",
      query: obj,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getTooldata(obj) {
    let body = {
      target: "getProfileDef",
      query: obj,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getHealthCount(obj) {
    let body = {
      target: "getHealthLibCount",
      query: obj,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getHealthRegex(obj) {
    let body = {
      target: "getHealthRegex",
      query: obj,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        
        resolve(result)
      }, reject);
    })
  }
  async getAllPOP(obj) {
    let body = {
      target: "getPOPDef",
      query: obj,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        
        resolve(result)
      }, reject);
    })
  }
  async getProductCount(obj) {
    let body = {
      target: "getProductsCount",
      query: obj,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getAllCropData(obj) {
    let body = {
      target: "getDataDef",
      query: obj,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getProductsRegex(obj) {
    let body = {
      target: "getproductsRegex",
      query: obj,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getHealthLib(obj) {
    let body = {
      target: "getHealthLib",
      query: obj,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getProfileDefData(obj) {
    let body = {
      target: "getProfileDef",
      query: obj,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getAllHealth(obj) {
    let body = {
      target: "getHealthDef",
      query: obj,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }

  async postPOP(pop: POP) {
    let body = {
      target: "savePOPDef",
      source: pop,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }

  async pushProduct(product: Product) {
    let body = {
      target: "saveProducts",
      source: product,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async postCropdata(cropdata: CropData) {
    let body = {
      target: "saveDataDef",
      source: cropdata,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async postHealthdiagnosis(individualHealth: IndividualHealth) {
    let body = {
      target: "saveHealthLib",
      source: individualHealth,
      lKey: "Profile"
    }
    console.log("@@Individual health:",individualHealth)
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async postHealthCollection(healthcollection: any) {
    let body = {
      target: "saveHealthDef",
      source: healthcollection,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async postProfile(cropDataTool: CropDataTool) {
    let body = {
      target: "saveProfileDef",
      source: cropDataTool,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async updateProduct(product: Product) {
    let obj = {
      productuuId: product.productuuId,
      group: product.group
    }
    let body = {
      target: "updateProducts",
      query: obj,
      source: product,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async updateProfileDef(data, selectedData) {
    var obj = {
      maincropId: selectedData.maincropId,
      group: selectedData.group
    }
    let body = {
      target: "updateProfileDef",
      query: obj,
      source: data,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async updateVarietyProfileDef(data, selectedVarietyData) {
    var obj = {
      cropId: selectedVarietyData.cropId,
      group: selectedVarietyData.group
    }
    let body = {
      target: "updateProfileDef",
      query: obj,
      source: data,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        
        resolve(result)
      }, reject);
    })
  }
  async updateCropdata(data) {
    var obj = {
      cropDataId: data.cropDataId,
      group: data.group
    }
    let body = {
      target: "updateDataDef",
      query: obj,
      source: data,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async updateHealthCollection(data) {
    var obj = {
      healthDiagnosisId: data.healthDiagnosisId,
      group: data.group
    }
    let body = {
      target: "updateHealthDef",
      query: obj,
      source: data,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        
        resolve(result)
      }, reject);
    })
  }
  async updatePOP(data) {
    var obj = {
      popId: data.popId,
      group: data.group
    }
    let body = {
      target: "updatePOPDef",
      query: obj,
      source: data,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async updateProfile(data) {
    var obj = {
      profileId: data.profileId,
      group: data.group
    }
    let body = {
      target: "updateProfileDef",
      query: obj,
      source: data,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async updateHealth(individualHealth: IndividualHealth) {
    let obj = {
      healthId: individualHealth.healthId,
      group: individualHealth.group
    }
    let body = {
      target: "updateHealthLib",
      query: obj,
      source: individualHealth,
      lKey: "Profile"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }

  gotoMainpage() {
    this.gotoMain.emit();
  }
  getResidueData() {
    return this.totalResidueData;
  }
  savePop() {
    console.log("savepop")
    this.savePopData.emit();
  }

  sendPopData(popData) {
    this.getPopData.emit(popData);
  }
}